'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_ClientSideAuthFailure$NoEmail$() {
}
export { $c_Lapp_auth_ClientSideAuthFailure$NoEmail$ as $c_Lapp_auth_ClientSideAuthFailure$NoEmail$ };
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.constructor = $c_Lapp_auth_ClientSideAuthFailure$NoEmail$;
/** @constructor */
function $h_Lapp_auth_ClientSideAuthFailure$NoEmail$() {
}
export { $h_Lapp_auth_ClientSideAuthFailure$NoEmail$ as $h_Lapp_auth_ClientSideAuthFailure$NoEmail$ };
$h_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype = $c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype;
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.hashCode__I = (function() {
  return (-544254405);
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.toString__T = (function() {
  return "NoEmail";
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.productPrefix__T = (function() {
  return "NoEmail";
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_ClientSideAuthFailure$NoEmail$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_auth_ClientSideAuthFailure$NoEmail$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_ClientSideAuthFailure$NoEmail$, "app.auth.ClientSideAuthFailure$NoEmail$", ({
  Lapp_auth_ClientSideAuthFailure$NoEmail$: 1,
  Lapp_auth_ClientSideAuthFailure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_auth_ClientSideAuthFailure$NoEmail$ as $d_Lapp_auth_ClientSideAuthFailure$NoEmail$ };
var $n_Lapp_auth_ClientSideAuthFailure$NoEmail$;
function $m_Lapp_auth_ClientSideAuthFailure$NoEmail$() {
  if ((!$n_Lapp_auth_ClientSideAuthFailure$NoEmail$)) {
    $n_Lapp_auth_ClientSideAuthFailure$NoEmail$ = new $c_Lapp_auth_ClientSideAuthFailure$NoEmail$();
  }
  return $n_Lapp_auth_ClientSideAuthFailure$NoEmail$;
}
export { $m_Lapp_auth_ClientSideAuthFailure$NoEmail$ as $m_Lapp_auth_ClientSideAuthFailure$NoEmail$ };
//# sourceMappingURL=app.auth.-Client-Side-Auth-Failure$-No-Email$.js.map
